<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Banner Image</label>
          <div class="group-item">
            <div>
              <v-checkbox v-model="fields.bannerImage.useBannerMobile" label="Use banner mobile" hide-details />
              <div v-if="fields.bannerImage.useBannerMobile">
                <UploadImage
                  @callback="handleUploadBannerMobile"
                  :image="{ imageSrc: fields.bannerImage.bannerMobile }"
                  :height="`160`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveBannerMobile"
                />
              </div>
            </div>
            <div>
              <UploadImage
                @callback="handleUploadBannerDesktop"
                :image="{ imageSrc: fields.bannerImage.bannerDesktop }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBannerDesktop"
              />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content Wrapper</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model.number="fields.wrapContent.widthContent"
                  type="number"
                  label="Content width"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.wrapContent.paddingTop"
                  type="number"
                  label="Padding top"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.wrapContent.paddingBottom"
                  type="number"
                  label="Padding bottom"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col> -->
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Tags</label>
              <input type="checkbox" v-model="fields.tags.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddTag">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Tag</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row class="mb-3">
              <v-col cols="12" md="3">
                <ColorPicker
                  defaultColor="#ffffff23"
                  v-model="fields.tags.backgroundColorTag"
                  label="Background"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <ColorPicker
                  default-color="#ffffff"
                  v-model="fields.tags.textColorTag"
                  label="Text color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <ColorPicker
                  default-color="#ffffff"
                  v-model="fields.tags.borderColor"
                  label="Border color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model.number="fields.tags.borderRadius"
                  type="number"
                  label="Border radius"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.tags.items" :key="`rivoneed-tag-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Tag {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveTag(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field v-model="item.text" label="Text" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Text Content</label>
            <input type="checkbox" v-model="fields.textContent.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.textContent.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Rating</label>
            <input type="checkbox" v-model="fields.rating.show" />
          </div>
          <div v-if="fields.rating.show" class="group-item">
            <v-row align="center">
              <v-col cols="12" md="6">
                <v-rating
                  color="warning"
                  background-color="#c1c1c1"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="5"
                  size="24"
                  v-model="fields.rating.value"
                ></v-rating>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.rating.text" label="Rating Text" hide-details />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Pills</label>
              <input type="checkbox" v-model="fields.pills.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddPill">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Pill</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row class="mb-3">
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.pills.background" label="Pill background" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.pills.color" label="Pill text color" hide-details />
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.pills.items" :key="`rivoneed-pill-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Pill {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemovePill(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadPillIcon(obj, index)"
                      :image="{ imageSrc: item.icon || '' }"
                      :height="`120`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemovePillIcon(index)"
                    />
                  </div>
                  <v-text-field v-model="item.text" label="Text" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Small Images</label>
              <input type="checkbox" v-model="fields.smallImages.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddSmallImage">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Image</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.smallImages.items" :key="`small-image-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Image {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveSmallImage(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadSmallImage(obj, index)"
                    :image="{ imageSrc: item.src || '' }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveSmallImageSrc(index)"
                  />
                  <v-text-field v-model="item.href" class="mt-3" label="Link" hide-details />
                  <v-text-field v-model="item.alt" class="mt-3" label="Alt" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';

const defaultSmallImage = '';

export default {
  name: 'card-banner-rivoneed-section-editor',
  components: {
    UploadImage,
    ButtonPrimary,
    SectionSettingsContainerFuild,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Banner Rivoneed Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        bannerImage: {
          useBannerMobile: false,
          bannerDesktop: '',
          bannerMobile: '',
        },
        wrapContent: {
          widthContent: 1200,
          paddingTop: 40,
          paddingBottom: 40,
        },
        tags: {
          show: true,
          backgroundColorTag: '#ffffff23',
          textColorTag: '#ffffff',
          borderRadius: 10,
          borderColor: '#ffffff',
          items: [],
        },
        textContent: {
          show: true,
          content:
            '<h2>Multi-Function Magnetic Swivel Work Light</h2><p>No more holding a light. The magnet holds it for you, the swivel head lights every corner, and one charge lasts your whole weekend of repairs.</p>',
        },
        rating: {
          show: true,
          value: 4,
          text: '21 Vélemény',
        },
        pills: {
          show: true,
          background: '#ffffff',
          color: '#000000',
          items: [],
        },
        button: {
          show: true,
          backgroundColor: '#ff0000',
          color: '#ffffff',
          radius: 4,
          text: 'Buy Now',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: { show: false, src: '' },
          subBtn: { show: false, text: '' },
        },
        smallImages: {
          show: true,
          items: [],
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        bannerImage: { ...this.fields.bannerImage, ...(extract.bannerImage || {}) },
        wrapContent: { ...this.fields.wrapContent, ...(extract.wrapContent || {}) },
        tags: { ...this.fields.tags, ...(extract.tags || {}) },
        textContent: { ...this.fields.textContent, ...(extract.textContent || {}) },
        rating: { ...this.fields.rating, ...(extract.rating || {}) },
        pills: { ...this.fields.pills, ...(extract.pills || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
        smallImages: { ...this.fields.smallImages, ...(extract.smallImages || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBannerRivoneed(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddTag() {
      this.fields.tags.items.push({ text: 'Snap On. Whole Engine Bay Lights Up.' });
    },
    handleRemoveTag(index) {
      this.fields.tags.items.splice(index, 1);
    },
    handleAddPill() {
      this.fields.pills.items.push({
        icon: '',
        text: '3000LM Flood Light',
      });
    },
    handleRemovePill(index) {
      this.fields.pills.items.splice(index, 1);
    },
    handleUploadPillIcon(obj, index) {
      if (!this.fields.pills.items[index]) return;
      this.$set(this.fields.pills.items[index], 'icon', obj.imageSrc || '');
    },
    handleRemovePillIcon(index) {
      if (!this.fields.pills.items[index]) return;
      this.$set(this.fields.pills.items[index], 'icon', '');
    },
    handleAddSmallImage() {
      this.fields.smallImages.items.push({ src: defaultSmallImage, href: '#', alt: '' });
    },
    handleRemoveSmallImage(index) {
      this.fields.smallImages.items.splice(index, 1);
    },
    handleUploadSmallImage(obj, index) {
      if (!this.fields.smallImages.items[index]) return;
      this.$set(this.fields.smallImages.items[index], 'src', obj.imageSrc || '');
    },
    handleRemoveSmallImageSrc(index) {
      if (!this.fields.smallImages.items[index]) return;
      this.$set(this.fields.smallImages.items[index], 'src', '');
    },
    handleUploadBannerMobile(obj) {
      this.fields.bannerImage.bannerMobile = obj.imageSrc || '';
    },
    handleRemoveBannerMobile() {
      this.fields.bannerImage.bannerMobile = '';
    },
    handleUploadBannerDesktop(obj) {
      this.fields.bannerImage.bannerDesktop = obj.imageSrc || '';
    },
    handleRemoveBannerDesktop() {
      this.fields.bannerImage.bannerDesktop = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
